import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { _TEST1234 } from "../config/ApiConfig";
import { LoginForm } from "./Login/LoginForm";
import { LoginHeader } from "./Login/LoginHeader";
import { LoginFooter } from "./Login/LoginFooter";
import { useLogin } from "../authentication/useLogin";
import { IconButton } from "@/comn/components";

const CloseButton = () => {
    const { reset } = useLogin();
    const { t } = useTranslation();
    return (
        <IconButton
            icon="close"
            className="absolute left-full top-0 translate-y-full text-white bg-white/10"
            onClick={reset}
        >
            {t("B_CLS")}
        </IconButton>
    );
};

const RemoteLogin = (props: any) => {
    return (
        <>
            <img
                className="w-screen h-screen object-cover"
                src={process.env.PUBLIC_URL + "/imgs/img_login_bg.webp"}
                alt="login background image"
                title="login background image"
            />

            <div
                className={classNames(
                    "fixed overflow-y-auto w-screen h-screen top-0 left-0 flex flex-col items-center bg-black/40 backdrop-blur",
                    props.type === "tanesw" && "z-[9998]",
                )}
            >
                <div className={classNames("relative py-10 my-auto w-[520px]", "sm:w-[80vw]")}>
                    <LoginHeader />
                    <LoginForm remote={true} />
                    <LoginFooter />
                    {props.type === "tanesw" && <CloseButton />}
                </div>
            </div>
        </>
    );
};

export default RemoteLogin;
